import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectUnit } from 'state/actions/clan_units'

import UnitTooltip from 'containers/BattleRooms/components/UnitTooltip/UnitTooltip'
import KineticScrolling from 'components/KineticScrolling/KineticScrolling'
import Unit from '../Unit/Unit'

import { UnitDataPropTypes } from 'containers/BattleRooms/propTypes'

import styles from './UnitsCarousel.scss'

export class UnitsCarousel extends React.Component {
    static propTypes = {
        units: PropTypes.arrayOf(UnitDataPropTypes).isRequired,
        selectUnit: PropTypes.func.isRequired,
    }

    state = {
        hoveredUnitId: null,
    }

    showUnitTooltip = unitId => {
        this.setState({ hoveredUnitId: unitId })
    }

    render() {
        let units = [...this.props.units]
            .sort((unit1, unit2) => unit2.created_at - unit1.created_at)
            .map(unit => (
                <div
                    key={unit.id}
                    data-tip
                    data-for={UnitTooltip.id}
                    onMouseEnter={() => this.showUnitTooltip(unit.id)}
                    onMouseLeave={() => this.showUnitTooltip(null)}
                >
                    <Unit
                        type={unit.type}
                        maxVehicleLevel={unit.max_vehicle_level}
                        commanderNickname={unit.commander_nickname}
                        membersNumber={unit.members_number}
                        maxMembersNumber={unit.max_members_number}
                        isInBattle={unit.in_battle}
                        onClick={() => this.props.selectUnit(unit)}
                    />
                </div>
            ))

        if (units.length > 2) {
            units = (
                <KineticScrolling snap={365}>
                    {units}
                </KineticScrolling>
            )
        }

        return (
            <div className={styles.base}>
                {units}
                {this.state.hoveredUnitId && <UnitTooltip unitId={this.state.hoveredUnitId} />}
            </div>
        )
    }
}

const mapDispatchToProps = {
    selectUnit,
}

export default connect(null, mapDispatchToProps)(UnitsCarousel)


// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/UnitsCarousel/UnitsCarousel.jsx